





import type { Field } from '@getaccept/lib-shared/src/fields/types/field';
import { defineComponent, computed, watch } from '@vue/composition-api';
import type { PropType } from '@vue/composition-api';

export default defineComponent({
  name: 'CheckboxField',
  props: {
    field: { type: Object as PropType<Field>, required: true },
    disabled: { type: Boolean, required: true },
    pressSpace: { type: Boolean, required: true },
  },
  setup(props, { emit }) {
    watch(
      () => props.pressSpace,
      press => {
        if (press) {
          toggle();
        }
      }
    );

    const checked = computed(() => !!parseInt(props.field.value));
    const showRequired = computed(() => {
      if (props.disabled) {
        return false;
      }
      return props.field.isRequired;
    });

    const toggle = () => {
      if (!props.disabled) {
        emit('update', checked.value ? '' : '1');
      }
    };

    return {
      checked,
      showRequired,
      toggle,
    };
  },
});
